import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Image, OverlayTrigger, Tooltip } from "react-bootstrap";
import IconTime from "../../assets/icon-time.svg";
import info from "../../assets/info_crit.svg";
import {
  dateFormat,
  dayAgo,
  formatNumber,
  getBackgroundColorCode,
  getColorCode,
  isValidArray
} from "../../helper";
import { IIG_PATHS, PATHS } from "../../constant";
import { get, isString } from "lodash";
import { Pragati } from "../prgatiReview";
import { Nip } from "../nipReview";
import { Pli } from "../pliReview";
import { OrganizationTemplate, ReadMore, PreNode } from "../reusableComponent";
import { RedirectUser } from "../reusableComponent";
import { PmFoundationStone } from "../pmFoundationStone/pmFoundationStone";
import { CmPragatiYatra } from "../cmPragatiYatra/cmPragatiYatra";
import { CmFoundationStone } from "../cmFoundationStone/cmFoundationStone";
import { PmgsHipimage } from "../pmgsHipp/pmgsHip";
import { PmGatiShakti } from "../pmGatiShakti/pmGatiShakti";
import { iigBaseUrl } from "../../globalConfig";
import { projectFormLabel } from "../../helper";
import { March24 } from "../march24";
//import useZoomLevel from "../projectList/detectZoomLevel";
import ZoomLevelProvider from "../projectList/ZoomLevelProvider";
import { PragatiPipeline } from "../prgatiReview/pragatiPipeline";
import CriticalityScore from "../../component/CriticalityBar";

class ProjectListTile extends Component {
  constructor() {
    super();
    this.state = {
      showOtherPPList: false,
      zoomPercentage: 100
    };
  }

  // componentDidMount() {
  //   this.updateZoom();
  //   window.addEventListener('resize', this.updateZoom);
  // }

  // componentWillUnmount() {
  //   window.removeEventListener('resize', this.updateZoom);
  // }

  // getZoomLevel = () => {
  //   return useZoomLevel();
  // }

  // updateZoom = () => {
  //   const zoom = this.getZoomLevel(); // Call the hook inside a helper function
  //   this.setState({ zoomPercentage: zoom });
  // };

  toggleOtherPPList = () => {
    this.setState({
      showOtherPPList: !this.state.showOtherPPList
    });
  };

  openProjectPageBasedOnLink = (includeReadMore = false) => {
    const { project } = this.props;
    const status = get(project, "status");
    const isIIGDraft = status === "CRIP_DRAFT";
    return (
      <>
        <Link
          to={{
            pathname: isIIGDraft
              ? PATHS.IIG_PROJECT_DETAIL
              : PATHS.PROJECT_DETAILS,
            search: `?projectId=${get(project, "id")}`,
            state: {
              projectId: get(project, "id"),
              isEdit: false
            }
          }}
        >
          {includeReadMore ? (
            <ReadMore
              content={get(project, "name", "NA")}
              clamp={2}
              displayExpandButtons={false}
              lineHeightTitle={1.3}
            />
          ) : (
            <> #{get(project, "displayId", "NA")}</>
          )}
        </Link>
      </>
    );
  };

  openProjectPageBasedOnCommonLink = (includeReadMore = false) => {
    const { project } = this.props;
    const iigProjectReferenceId = get(project, "iigProjectReferenceId");
    return (
      <>
        <a
        // href={
        //   iigBaseUrl +
        //   IIG_PATHS.IIG_PROJECT_DETAIL +
        //   "?iigProject=" +
        //   iigProjectReferenceId
        // }
        // target="_blank"
        >
          {includeReadMore ? (
            <ReadMore
              content={get(project, "name", "NA")}
              clamp={2}
              displayExpandButtons={false}
            />
          ) : (
            <> #{get(project, "commonId")}</>
          )}
        </a>
      </>
    );
  };

  // detectZoomLevel = () => {
  //   let zoom = Math.round((window.outerWidth / window.innerWidth) * 100);

  //   this.setState({
  //     zoom
  //   });
  //   return zoom;
  // };
  handleZoomChange = zoom => {
    this.setState({ zoomPercentage: zoom });
  };

  render() {
    const { project, data } = this.props;
    const { showOtherPPList } = this.state;
    const iigProjectCommonId = get(project, "commonId");
    const upProjectId = get(project, "upProjectId");
    const Critscore = get(project, "criticalScore", null);
    const status =
      isString(get(project, "status")) &&
      get(project, "status")
        .replace(/[_]/, " ")
        .toLowerCase();
    // const isIIGDraft = status === "iig draft";
    const isIIGDraft = status === "crip draft";
    const isResolved =
      get(project, "projectStatusWithRespectToIssueStatus") === "RESOLVED";
    const projectResolutionDate = get(project, "projectResolutionDate")
      ? dateFormat(get(project, "projectResolutionDate"))
      : "NA";
    const createdBy =
      project.projectPPList && project.projectPPList.length
        ? project.projectPPList[0]
        : null;
    const projectPPList =
      project.projectPPList && project.projectPPList.length
        ? project.projectPPList
        : [];
    function getUniqueOrganizations(data) {
      // Filter out null values before creating the set
      const filteredData = data.filter(item => item.organizationGroup !== null);
      // Create a Set to store unique organization groups
      const uniqueOrgs = new Set(
        filteredData.map(item => item.organizationGroup)
      );
      // Convert the Set back to an array
      return Array.from(uniqueOrgs);
    }
    const uniqueOrganizations = getUniqueOrganizations(projectPPList);
    const organistionArr =
      projectPPList.filter(
        item => item !== null && item.organizationGroup !== ""
      ) || [];
    const projectCost = formatNumber(
      get(project, "revisedCost", 0) || get(project, "cost", "0")
    );
    let projectLocations = [];
    if (isValidArray(get(project, "locations"))) {
      // projectLocations = get(project, "locations").map((location, index) =>
      //   index < get(project, "locations").length - 1
      //     ? location.state + ", "
      //     : location.state + ""
      // );
      if (get(project, "sponsoredByCategory") === "STATE") {
        projectLocations = get(project, "locations")
          .map(location => {
            if (location.districtIdName.length > 0) {
              return location.districtIdName
                .map((district, districtIndex) => {
                  return district.name;
                })
                .join(", ");
            } else {
              return "-";
            }
          })
          .join(", ");
      } else {
        projectLocations = get(project, "locations").map((location, index) =>
          index < get(project, "locations").length - 1
            ? location.state + ", "
            : location.state + ""
        );
      }
    }

    return (
      <React.Fragment>
        {/* <ZoomLevel />; */}
        <ZoomLevelProvider onZoomChange={this.handleZoomChange} />
        <div
          className="project-list-box-wrapper"
          data-test="project-list-wrapper"
        >
          <div className="project-list-box-top">
            <div className="project-box-top-upper">
              <div className="project-name-section">
                <div className="d-flex flex-wrap">
                  <div>
                    {iigProjectCommonId && (
                      <div className="id-wrapper-box mr-2">
                        <p className="border-right mb-1 common-project-id">
                          COMMON PROJECT ID{" "}
                          <b className="link-color mr-2 iig-project-link-color">
                            {this.openProjectPageBasedOnCommonLink()}
                          </b>
                        </p>
                      </div>
                    )}
                    {upProjectId && (
                      <div className="id-wrapper-box mr-2">
                        <p className="border-right mb-1 common-project-id">
                          CMIS PROJECT ID{" "}
                          <b className="link-color mr-2 iig-project-link-color">
                            #{upProjectId}
                          </b>
                        </p>
                      </div>
                    )}
                  </div>
                  <div className="project-id mb-1">
                    PMG Project Id{" "}
                    <b data-test="project-id">
                      {this.openProjectPageBasedOnLink()}
                    </b>
                  </div>
                  {/* {projectPPList &&
                    projectPPList.map(item => {
                      if (item !== null) {
                        return (
                          <OrganizationTemplate
                            title={item.organizationGroup}
                            classes="organisation mb-2 g"
                          />
                        );
                      }
                    })} */}
                  {uniqueOrganizations.map((organization, index) => (
                    <OrganizationTemplate
                      key={index}
                      title={organization}
                      classes="organisation mb-2 g"
                    />
                  ))}
                </div>
                <h2 className="project-name" data-test="project name">
                  {this.openProjectPageBasedOnLink(true)}
                </h2>
                {get(project, "projectStatusWithRespectToIssueStatus") ||
                get(project, "projectCompletionDTO.status") ? (
                  <div className="project-status">
                    {get(project, "projectStatusWithRespectToIssueStatus") &&
                    get(project, "projectStatusWithRespectToIssueStatus") !==
                      "NO ISSUES" ? (
                      <span
                      /** className={getColorCode(
        get(project, "projectStatusWithRespectToIssueStatus")
      )} */
                      >
                        {get(project, "projectStatusWithRespectToIssueStatus")}
                      </span>
                    ) : null}

                    {/* {get(project, "projectCompletionDTO.status") ? (
                      <span
                      >
                        {get(project, "projectCompletionDTO.status") ===
                        "NO IMPLEMENTATION"
                          ? "UNDER DEVELOPMENT"
                          : get(project, "projectCompletionDTO.status")}
                      </span>
                    ) : null} */}
                    {get(project, "projectCompletionDTO.status") &&
                    get(project, "projectCompletionDTO.status") !==
                      "NO IMPLEMENTATION" ? (
                      <span
                      /** className={getColorCode(
                          get(project, "projectCompletionDTO.status")
                        )} */
                      >
                        {get(project, "projectCompletionDTO.status")}
                      </span>
                    ) : null}
                  </div>
                ) : null}
              </div>
              <div className="project-stage-section">
                <div
                  className={`${getBackgroundColorCode(
                    status
                  )} project-stage-background`}
                >
                  <span className={`project-stage`} data-test="project-stage">
                    {status}
                  </span>
                </div>
                {Critscore && (
                  <div
                    style={{
                      fontSize: "12px",
                      fontFamily: "mpsb",
                      paddingBottom: "4px",
                      marginTop: "-2px"
                    }}
                  >
                    Criticality Score (
                    {Critscore !== null
                      ? parseFloat(Critscore).toFixed(1)
                      : "--"}
                    /5)
                    <OverlayTrigger
                      defaultShow={false}
                      placement={"top"}
                      overlay={
                        <Tooltip id={``} className={"critical-rate-tooltip"}>
                          <span>
                            Project criticality based on delays, issue severity,
                            and implementation risks
                          </span>
                          <br />
                          <span className="AI-tooltip-text">
                            The score is AI-generated and may not be fully
                            accurate
                          </span>
                        </Tooltip>
                      }
                    >
                      <Image
                        style={{ paddingBottom: "1px", paddingLeft: "2px" }}
                        src={info}
                      />
                    </OverlayTrigger>
                  </div>
                )}
                {Critscore && (
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <CriticalityScore
                      value={get(project, "criticalScore", null)}
                    />
                  </div>
                )}
                {get(project, "terminatedDate", null) ? (
                  <div className="date-terminated">
                    <Image src={IconTime} alt="Time" />
                    <span>
                      {dateFormat(get(project, "terminatedDate", null))}
                    </span>
                  </div>
                ) : null}
                {isResolved ? (
                  <div className="resolution-date">
                    <div> Resolved on</div>
                    <div className="second-row">
                      <Image src={IconTime} alt="Time" />
                      <span>{projectResolutionDate}</span>
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
            <div className="project-box-top-lower">
              {this.state.zoomPercentage >= 125 ? (
                <div className="project-details-left-section-1">
                  <div className="project-detail-unit display-mobile">
                    <div className="heading-text">Project Id:</div>
                    <b>{this.openProjectPageBasedOnLink()}</b>
                  </div>
                  {organistionArr && organistionArr.length ? (
                    <div className="project-detail-unit display-mobile">
                      <div className="heading-text">Organisation:</div>
                      <div>
                        {organistionArr.map((item, index) => (
                          <span>
                            {item.organizationGroup}
                            {index < organistionArr.length - 1 ? ", " : ""}{" "}
                          </span>
                        ))}
                      </div>
                    </div>
                  ) : null}
                  <div className="project-detail-unit">
                    <div className="heading-text">Sponsored by:</div>
                    <span>{get(project, "sponsoredBy")}</span>
                  </div>
                  {get(project, "sponsoringDepartment") ? (
                    <div
                      className="project-detail-unit"
                      style={{
                        display:
                          get(project, "sponsoredByCategory") == "STATE"
                            ? "none"
                            : null
                      }}
                    >
                      <div className="heading-text">
                        {projectFormLabel(
                          get(project, "sponsoredByid"),
                          "department",
                          "Sponsoring Department"
                        )}
                        :
                      </div>
                      <span>{get(project, "sponsoringDepartment.name")}</span>
                    </div>
                  ) : null}
                  {get(project, "sponsoringDepartment") ? (
                    <div
                      className="project-detail-unit"
                      style={{
                        display:
                          get(project, "sponsoredBy") == "Arunachal Pradesh" &&
                          get(project, "sponsoredByCategory") == "STATE"
                            ? null
                            : "none"
                      }}
                    >
                      <div className="heading-text">
                        {projectFormLabel(
                          get(project, "sponsoredByid"),
                          "department",
                          "Beneficiary Department"
                        )}
                        :
                      </div>
                      <span>{get(project, "sponsoringDepartment.name")}</span>
                    </div>
                  ) : null}
                  {get(project, "sponsoringDepartment") ? (
                    <div
                      className="project-detail-unit"
                      style={{
                        display:
                          get(project, "sponsoredBy") != "Arunachal Pradesh" &&
                          get(project, "sponsoredByCategory") == "STATE"
                            ? null
                            : "none"
                      }}
                    >
                      <div className="heading-text">
                        {projectFormLabel(
                          get(project, "sponsoredByid"),
                          "department",
                          "Sponsoring Department"
                        )}
                        :
                      </div>
                      <span>{get(project, "sponsoringDepartment.name")}</span>
                    </div>
                  ) : null}
                  {isValidArray(get(project, "locations")) ? (
                    <div className="project-detail-unit">
                      <div className="heading-text">Project Location(s):</div>
                      <ReadMore
                        content={<span>{projectLocations}</span>}
                        clamp={3}
                        displayExpandButtons={false}
                      />
                    </div>
                  ) : null}
                  {get(project, "projectCompletionDTO") &&
                  get(project, "projectCompletionDTO.percentage") ? (
                    <div className="physical-progress-wrapper">
                      <div className="progress-upper d-flex align-items-center fw-bold">
                        Physical Progress:{" "}
                        <span className="d-inline-block">
                          {get(project, "projectCompletionDTO.percentage")}%
                        </span>
                      </div>
                      {get(
                        project,
                        "projectCompletionDTO.physicalProgressAsOf"
                      ) ? (
                        <div className="progress-lower">
                          (as of{" "}
                          {dateFormat(
                            get(
                              project,
                              "projectCompletionDTO.physicalProgressAsOf"
                            )
                          )}
                          )
                        </div>
                      ) : get(project, "projectCompletionDTO.date") ? (
                        <div className="progress-lower">
                          (as of{" "}
                          {dateFormat(
                            get(project, "projectCompletionDTO.date")
                          )}
                          )
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                </div>
              ) : (
                <div className="project-details-left-section">
                  <div className="project-detail-unit display-mobile">
                    <div className="heading-text">Project Id:</div>
                    <b>{this.openProjectPageBasedOnLink()}</b>
                  </div>
                  {organistionArr && organistionArr.length ? (
                    <div className="project-detail-unit display-mobile">
                      <div className="heading-text">Organisation:</div>
                      <div>
                        {organistionArr.map((item, index) => (
                          <span>
                            {item.organizationGroup}
                            {index < organistionArr.length - 1 ? ", " : ""}{" "}
                          </span>
                        ))}
                      </div>
                    </div>
                  ) : null}
                  <div className="project-detail-unit">
                    <div className="heading-text">Sponsored by:</div>
                    <span>{get(project, "sponsoredBy")}</span>
                  </div>
                  {get(project, "sponsoringDepartment") ? (
                    <div
                      className="project-detail-unit"
                      style={{
                        display:
                          get(project, "sponsoredByCategory") == "STATE"
                            ? "none"
                            : null
                      }}
                    >
                      <div className="heading-text">
                        {projectFormLabel(
                          get(project, "sponsoredByid"),
                          "department",
                          "Sponsoring Department"
                        )}
                        :
                      </div>
                      <span>{get(project, "sponsoringDepartment.name")}</span>
                    </div>
                  ) : null}
                  {get(project, "sponsoringDepartment") ? (
                    <div
                      className="project-detail-unit"
                      style={{
                        display:
                          get(project, "sponsoredBy") == "Arunachal Pradesh" &&
                          get(project, "sponsoredByCategory") == "STATE"
                            ? null
                            : "none"
                      }}
                    >
                      <div className="heading-text">
                        {projectFormLabel(
                          get(project, "sponsoredByid"),
                          "department",
                          "Beneficiary Department"
                        )}
                        :
                      </div>
                      <span>{get(project, "sponsoringDepartment.name")}</span>
                    </div>
                  ) : null}
                  {get(project, "sponsoringDepartment") ? (
                    <div
                      className="project-detail-unit"
                      style={{
                        display:
                          get(project, "sponsoredBy") != "Arunachal Pradesh" &&
                          get(project, "sponsoredByCategory") == "STATE"
                            ? null
                            : "none"
                      }}
                    >
                      <div className="heading-text">
                        {projectFormLabel(
                          get(project, "sponsoredByid"),
                          "department",
                          "Sponsoring Department"
                        )}
                        :
                      </div>
                      <span>{get(project, "sponsoringDepartment.name")}</span>
                    </div>
                  ) : null}
                  {isValidArray(get(project, "locations")) ? (
                    <div className="project-detail-unit">
                      <div className="heading-text">Project Location(s):</div>
                      <ReadMore
                        content={<span>{projectLocations}</span>}
                        clamp={3}
                        displayExpandButtons={false}
                      />
                    </div>
                  ) : null}
                  {get(project, "projectCompletionDTO") &&
                  get(project, "projectCompletionDTO.percentage") ? (
                    <div className="physical-progress-wrapper">
                      <div className="progress-upper d-flex align-items-center fw-bold">
                        Physical Progress:{" "}
                        <span className="d-inline-block">
                          {get(project, "projectCompletionDTO.percentage")}%
                        </span>
                      </div>
                      {get(
                        project,
                        "projectCompletionDTO.physicalProgressAsOf"
                      ) ? (
                        <div className="progress-lower">
                          (as of{" "}
                          {dateFormat(
                            get(
                              project,
                              "projectCompletionDTO.physicalProgressAsOf"
                            )
                          )}
                          )
                        </div>
                      ) : get(project, "projectCompletionDTO.date") ? (
                        <div className="progress-lower">
                          (as of{" "}
                          {dateFormat(
                            get(project, "projectCompletionDTO.date")
                          )}
                          )
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                </div>
              )}

              {this.state.zoomPercentage >= 110 &&
              get(createdBy, "name", null).length >= 9 ? (
                <div className="project-details-right-section-1">
                  <div className="project-impl-mode">
                    Impl. Mode - {get(project, "implMode", "NA")}
                  </div>
                  <div className="project-created-date">
                    <span
                      className={`project-created-by
                                                      ${
                                                        createdBy &&
                                                        createdBy.verified
                                                          ? "verified-user-1"
                                                          : ""
                                                      }
                                                      `}
                    />
                    <span className="first-pp-name">
                      <RedirectUser
                        title={get(createdBy, "name", null)}
                        id={get(createdBy, "id", null)}
                        isProjectProponentDetail={true}
                        data-test="first-pp-name"
                      />
                    </span>
                    {projectPPList && projectPPList.length > 1 ? (
                      <div
                        className={`dropdown field-sort ${
                          showOtherPPList ? "visible" : ""
                        }`}
                        onClick={this.toggleOtherPPList}
                      >
                        <div
                          className={`dropdown-overlay ${
                            showOtherPPList ? "visible" : ""
                          }`}
                        />
                        <div className="dropdown-selected-value">
                          + {projectPPList.length - 1}
                        </div>
                        <div className="dropdown-option-list hidden-mobile">
                          <div className="dropdown-option-list-heading" />
                          {projectPPList
                            ? projectPPList.map((value, index) => {
                                if (index !== 0) {
                                  return (
                                    <RedirectUser
                                      title={get(value, "name", null)}
                                      id={get(value, "id", null)}
                                      isProjectProponentDetail={true}
                                    />
                                  );
                                }
                              })
                            : null}
                        </div>
                      </div>
                    ) : null}
                    <span className="project-created-on">
                      {get(project, "verificationDate")
                        ? `Verified on ${dateFormat(
                            get(project, "verificationDate", null)
                          )}`
                        : `${isIIGDraft ? "Imported on" : "Created on"}
                                      ${dateFormat(
                                        get(project, "createdDate", null)
                                      )}`}
                    </span>
                  </div>
                </div>
              ) : (
                <div className="project-details-right-section">
                  <div className="project-impl-mode">
                    Impl. Mode - {get(project, "implMode", "NA")}
                  </div>
                  <div className="project-created-date">
                    <span
                      className={`project-created-by
                                        ${
                                          createdBy && createdBy.verified
                                            ? "verified-user"
                                            : ""
                                        }
                                        `}
                    />
                    <span className="first-pp-name">
                      <RedirectUser
                        title={get(createdBy, "name", null)}
                        id={get(createdBy, "id", null)}
                        isProjectProponentDetail={true}
                        data-test="first-pp-name"
                      />
                    </span>
                    {projectPPList && projectPPList.length > 1 ? (
                      <div
                        className={`dropdown field-sort ${
                          showOtherPPList ? "visible" : ""
                        }`}
                        onClick={this.toggleOtherPPList}
                      >
                        <div
                          className={`dropdown-overlay ${
                            showOtherPPList ? "visible" : ""
                          }`}
                        />
                        <div className="dropdown-selected-value">
                          + {projectPPList.length - 1}
                        </div>
                        <div className="dropdown-option-list hidden-mobile">
                          <div className="dropdown-option-list-heading" />
                          {projectPPList
                            ? projectPPList.map((value, index) => {
                                if (index !== 0) {
                                  return (
                                    <RedirectUser
                                      title={get(value, "name", null)}
                                      id={get(value, "id", null)}
                                      isProjectProponentDetail={true}
                                    />
                                  );
                                }
                              })
                            : null}
                        </div>
                      </div>
                    ) : null}
                    <span className="project-created-on">
                      {get(project, "verificationDate")
                        ? `Verified on ${dateFormat(
                            get(project, "verificationDate", null)
                          )}`
                        : `${isIIGDraft ? "Imported on" : "Created on"}
                        ${dateFormat(get(project, "createdDate", null))}`}
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="project-list-box-bottom">
            <div className="project-bottom-left">
              <div className="project-list-tile-format justify-content-between">
                <div className="project-description">
                  <PreNode>
                    <ReadMore content={get(project, "description")} clamp={2} />
                  </PreNode>
                </div>
                <div className="project-bottom-right">
                  <div className="project-cost-section">
                    <label>Project Cost</label>
                    <p>
                      {parseFloat(projectCost) !== 0
                        ? `₹ ${projectCost} Cr.`
                        : "N/A"}
                    </p>
                  </div>
                </div>
              </div>
              <div className="project-issues-details">
                Issue(s) Open :{" "}
                <span>{get(project, "openIssuesCount", 0)}</span>
              </div>

              <div className="project-issues-details space-border-left">
                Issue(s) Resolved :{" "}
                <span>{get(project, "resolvedIssuesCount", 0)}</span>
              </div>
              <div className="d-flex tags-contatiner">
                <Pragati
                  className={"pragati-review"}
                  isValidProject={get(project, "pragatiDTO.pragatiReview")}
                />
                {/* <PragatiPipeline
                  className={"pragati-review"}
                  isValidProject={get(project, "pragatiDTO.pragatiPipeline")}
                /> */}

                <PragatiPipeline
                  className={"pragati-review"}
                  isValidProject={
                    !get(project, "pragatiDTO.pragatiReview") &&
                    get(project, "pragatiDTO.pragatiPipeline")
                  }
                />
                <Nip
                  className={"pragati-review"}
                  isValidProject={get(project, "nipDTO.nipReview")}
                />
                <PmFoundationStone
                  className={"pragati-review"}
                  isValidProject={get(
                    project,
                    "pmFoundationStoneDTO.pmFoundationStone"
                  )}
                />
                <CmPragatiYatra
                  className={"pragati-review"}
                  isValidProject={get(
                    project,
                    "cmPragatiYatraDTO.cmPragatiYatra"
                  )}
                />
                <CmFoundationStone
                  className={"pragati-review"}
                  isValidProject={get(
                    project,
                    "cmFoundationStoneDTO.cmFoundationStone"
                  )}
                />
                <PmgsHipimage
                  className={"pragati-review"}
                  isValidProject={get(project, "pmGsHipDTO.pmgsHip")}
                />
                <Pli
                  className={"pragati-review"}
                  isValidProject={get(project, "pliDTO.pli")}
                />
                <March24
                  className={"pragati-review"}
                  isValidProject={get(project, "march24DTO.march24")}
                />
                <PmGatiShakti
                  className={"pragati-review"}
                  isValidProject={get(
                    project,
                    "pmGatiShaktiNewDTO.pmGatiShaktiNew"
                  )}
                />
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ProjectListTile;
